export const CLASSIFICATION_LABELS: Record<string, string> = {
  all: 'All Calls',
  answered: 'Answered Calls',
  not_answered: 'Not Answered',
  no_answer: 'No Answer',
  busy: 'Busy',
  voicemail: 'Voicemail',
  picked_up: 'Picked Up (>25s)',
  engaged: 'Engaged Calls (>25s)',
  immediate_hangup: 'Immediate Hang-up (<=25s)',
  sales_pipeline: 'Sales Pipeline',
  vehicle_chosen: 'Vehicle Chosen',
  finance: 'Finance Request',
  outright: 'Outright Purchase',
  link_sent: 'Deposit Link Sent',
  link_clicked: 'Link Clicked',
  finance_link_sent: 'Finance Link Sent',
  finance_link_clicked: 'Finance Link Clicked',
  showroom_booked: 'Showroom Booked',
  inquiries: 'General Inquiries',
  callback_requested: 'Callback Requested',
  already_purchased: 'Already Purchased',
  finance_inquiry: 'Finance Inquiry',
  refund_request: 'Refund Request',
  administrative: 'Administrative',
  vehicle_not_found: 'Vehicle Not Found',
  // Newcross-specific
  nc_answered: 'Answered (NC)',
  availability_captured: 'Availability Captured',
  availability_confirmed: 'Availability Confirmed',
  availability_potential: 'Availability Potential',
  availability_consented: 'Availability Consented',
  availability_consent_declined: 'Availability Consent Declined',
  availability_consent_not_obtained: 'Availability Consent Not Obtained',
  future_availability: 'Future Availability',
  nc_callback_requested: 'Callback Requested (NC)',
  transferred_to_human: 'Transferred to Human',
  shift_confirmed: 'Shift Confirmed',
  shift_declined: 'Shift Declined',
  canceled: 'Canceled',
  failed: 'Failed',
  pending: 'Pending/Unknown',
  picked_up_any: 'Picked Up',
};

export const OUTCOME_COLORS: Record<string, string> = {
  LEAD_CAPTURED: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-300',
  CALLBACK_REQUESTED: 'bg-blue-100 text-blue-700 dark:bg-blue-900/50 dark:text-blue-300',
  ALREADY_PURCHASED: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300',
  FINANCE_INQUIRY: 'bg-amber-100 text-amber-700 dark:bg-amber-900/50 dark:text-amber-300',
  REFUND_REQUEST: 'bg-rose-100 text-rose-700 dark:bg-rose-900/50 dark:text-rose-300',
  ADMINISTRATIVE: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300',
  PICKED_UP: 'bg-teal-100 text-teal-700 dark:bg-teal-900/50 dark:text-teal-300',
  NO_ANSWER: 'bg-orange-100 text-orange-700 dark:bg-orange-900/50 dark:text-orange-300',
  BUSY: 'bg-rose-100 text-rose-600 dark:bg-rose-900/50 dark:text-rose-300',
  VOICEMAIL: 'bg-purple-100 text-purple-700 dark:bg-purple-900/50 dark:text-purple-300',
  ATTENDING_USD_EVENT:
    'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-300',
  NOT_ATTENDING_USD_EVENT: 'bg-red-100 text-red-700 dark:bg-red-900/50 dark:text-red-300',
  AVAILABLE_COOK: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-300',
  NOT_AVAILABLE_COOK: 'bg-red-100 text-red-700 dark:bg-red-900/50 dark:text-red-300',
};
